(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-showcase"] && !Shopify.designMode) return;
  try {
    
  class ShopByShowcase extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('.shop-by__link'));
      this.panels = Array.from(this.querySelectorAll('.shop-by-showcase__panel'));
      this.dragMoved = false;

      const list = this.querySelector('.shop-by__list');
      if (list) this.initDragScroll(list);

      this.items.forEach((item) => {
        item.addEventListener('click', this.onItemClick.bind(this, item));
      });
    }

    onItemClick(item, event) {
      if (this.dragMoved) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      this.selectItem(item);
    }

    selectItem(item) {
      this.items.forEach((current) => {
        const selected = current === item;
        current.classList.toggle('shop-by__link--active', selected);
        current.closest('.shop-by__item').classList.toggle('shop-by__item--active', selected);
        current.setAttribute('aria-current', selected);
      });

      const targetId = item.getAttribute('aria-controls');
      this.panels.forEach((panel) => {
        const selected = panel.id === targetId;
        panel.classList.toggle('shop-by-showcase__panel--active', selected);
        if (selected) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    initDragScroll(list) {
      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      list.addEventListener('mousedown', (event) => {
        isDown = true;
        this.dragMoved = false;
        list.classList.add('shop-by__list--dragging');
        startX = event.pageX;
        startScrollLeft = list.scrollLeft;
        event.preventDefault();
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        list.classList.remove('shop-by__list--dragging');
      });

      window.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        const delta = event.pageX - startX;
        if (Math.abs(delta) > 15) this.dragMoved = true;
        list.scrollLeft = startScrollLeft - delta;
      });
    }
  }

  customElements.define('shop-by-showcase', ShopByShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by"] && !Shopify.designMode) return;
  try {
    
  class ShopByTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', this.onKeydown.bind(this));
      });

      this.querySelectorAll('.shop-by__list').forEach((list) => this.initDragScroll(list));
    }

    initDragScroll(list) {
      let isDown = false;
      let moved = false;
      let startX = 0;
      let startScrollLeft = 0;

      list.addEventListener('mousedown', (event) => {
        isDown = true;
        moved = false;
        list.classList.add('shop-by__list--dragging');
        startX = event.pageX;
        startScrollLeft = list.scrollLeft;
        event.preventDefault();
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        list.classList.remove('shop-by__list--dragging');
      });

      window.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        const delta = event.pageX - startX;
        if (Math.abs(delta) > 15) moved = true;
        list.scrollLeft = startScrollLeft - delta;
      });

      list.addEventListener(
        'click',
        (event) => {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    selectTab(tab) {
      this.tabs.forEach((current) => {
        const selected = current === tab;
        current.classList.toggle('shop-by__tab--active', selected);
        current.setAttribute('aria-selected', selected);
        current.setAttribute('tabindex', selected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const selected = panel.id === tab.getAttribute('aria-controls');
        panel.classList.toggle('shop-by__panel--active', selected);
        if (selected) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let newIndex = null;

      if (event.code === 'ArrowRight') {
        newIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.code === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      }

      if (newIndex !== null) {
        event.preventDefault();
        this.tabs[newIndex].focus();
        this.selectTab(this.tabs[newIndex]);
      }
    }
  }

  customElements.define('shop-by-tabs', ShopByTabs);

  } catch(e) { console.error(e); }
})();
})();
